/*
    sidebar component should be a component usable for all main views
*/
import React, { useState } from "react";
import { rbac } from "../../index";
import t from "../../../../helpers/t";
import NewUserButton from "./NewUserButton";
import { ListItem } from "../../styled_components/exporter";
import { $, Foundation, moment, DropdownButton, Dropdown } from "../../../../../../vendor";
import { getApiHost } from "../../../../../Sync";
import { Biscuit } from "../../../../../utils";
import * as FileSaver from "../../../../../../vendor/FileSaver";
import SidebarFilter from "../../../../components/SidebarFilter";
import { getFilterData } from "../../../../../utils/Helper";

const UserSidebar = (props) => {
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const [globalFilter, setGlobalFilter] = useState({}); // set empty object, there are no filters set by default

  const [statusFilter, setStatusFilter] = useState({
    value:
      searchParams.get("active") !== null
        ? searchParams.get("active") === "1"
          ? "active"
          : "inactive"
        : "all",
  }); // 'all', 'active', 'inactive'
  const [roleFilter, setRoleFilter] = useState({
    value: searchParams.get("role") !== null ? searchParams.get("role") : "all",
  }); // 'all', 'admin', 'manager', 'booking-manager', 'mediator', optional: 'manager-location', 'garage-staff', 'guide'

  const onToggleLeftBar = (ev) => {
    $("#inb-c-sidebar").toggleClass("open");
    $("html,body").scrollTop(0);
  };

  const onStatusFilterChange = (val) => {
    setStatusFilter({ value: val }); // set status filter
    var clone = {};
    Object.assign(clone, globalFilter); // get current filter settings (all filter)

    if (val === "active") {
      // add status filter to global filter
      clone.active = "1";
      searchParams.set("active", "1");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else if (val === "inactive") {
      clone.active = "0";
      searchParams.set("active", "0");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else {
      delete clone["active"];
      searchParams.delete("active");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }

    setGlobalFilter(clone);
    props.setSelectedFilter(clone); // cloned object must be used because global filter is not yet updated
  };

  const onRoleFilterChange = (val) => {
    setRoleFilter({ value: val }); // set status filter
    var clone = {};
    Object.assign(clone, globalFilter); // get current filter settings (all filter)

    if (val === "all") {
      // remove role filter from global filter
      delete clone["role"];
      searchParams.delete("role");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else {
      clone.role = val;
      searchParams.set("role", val);
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }

    setGlobalFilter(clone);
    props.setSelectedFilter(clone); // cloned object must be used because global filter is not yet updated
  };

  const onExportXLS = () => {
    const that = this;
    let params = "",
      count = 0;

    for (var key in globalFilter) {
      if (count > 0) params += "&" + key + "=" + globalFilter[key];
      else params += "?" + key + "=" + globalFilter[key];
      count++;
    }

    const xmlHttp = new XMLHttpRequest();

    xmlHttp.open("GET", getApiHost() + "/users/export" + params, true);

    //  xmlHttp.setRequestHeader('Accept', 'application/json')
    xmlHttp.setRequestHeader("Authorization", "Bearer " + Biscuit.get("token"));
    xmlHttp.setRequestHeader("Content-Language", Biscuit.get("user.lang").replace("-", "_"));
    xmlHttp.setRequestHeader("Accept-Language", Biscuit.get("user.lang").replace("-", "_"));
    xmlHttp.responseType = "blob";

    xmlHttp.onload = function () {
      const blob = new Blob([xmlHttp.response], { type: "application/xls" });
      FileSaver.saveAs(blob, t("users") + " " + get_today() + ".xlsx");
    };
    xmlHttp.send(null);
  };

  const get_today = () => {
    let today = new Date();

    let day = today.getDate(); // Tag

    // Monatsangabe startet bei 0!
    let month = today.getMonth() + 1; // Monat

    let year = today.getFullYear(); // Jahr
    if (day < 10) {
      day = "0" + day;
    }
    if (month < 10) {
      month = "0" + month;
    }
    today = day + "." + month + "." + year;

    return today;
  };

  let styleClass = {};
  /*if(Biscuit.get('user.is_superuser') === 'true'){
    styleClass={minWidth:"280px"}
}*/
  const onToggleDropdown = (nextShow, meta) => {
    if (nextShow) {
      $(".sticky-top-sortbar").addClass("hide");
    } else {
      $(".sticky-top-sortbar").removeClass("hide");
    }
  };
  return (
    <aside id="inb-c-sidebar" className="resources-sidebar" style={{ float: "left" }}>
      <header className="inb-c-left-bar__title sticky-top">
        <h1 className="inb-page-title">{t("users", null, "capital")}</h1>
        <aside className="inb-c-item__actions">
          <DropdownButton
            id="dropdown-basic-button"
            title="..."
            drop="down"
            menuAlign="down"
            bsPrefix="button round"
            onToggle={onToggleDropdown}
          >
            <ul className="inb-dropdown__list" style={styleClass}>
              {false && (
                <li className="inb-order__edit">
                  <a className="help-link" href="/users/help">
                    <i className="ico-inb inb-fi-help"></i>
                    {t("help", null, "capital")}
                  </a>
                </li>
              )}
              {false && <li className="spacer"></li>}
              <li>
                <Dropdown.Item href="#" onClick={() => onExportXLS()}>
                  <i className="ico-inb inb-fi-excel"></i>
                  {t("export_xls", null, "capital")}
                </Dropdown.Item>
              </li>
              {/*<li>
                             <Dropdown.Item href='#' onClick={() => props.openVoucherCreate()}>
                                 <i className="ico-inb inb-fi-voucher"></i>
                                                {t('voucher for temporary user', null, 'capital')}
                                            </Dropdown.Item>
                                        </li>*/}
            </ul>
          </DropdownButton>
        </aside>
      </header>
      <div className="sticky-top-filter">
        {
          props.activeSubmenu == "user" && (
            <SidebarFilter
              id="inb-c-left-bar-flist--user-status"
              heading=""
              type="list"
              data={getFilterData(
                [
                  { name: t("all"), value: "all" },
                  { name: t("active"), value: "active" },
                  { name: t("inactive"), value: "inactive" },
                ],
                props.userSummaryPending,
                props.userSummary,
              )}
              dataKey="value"
              selected={statusFilter.value}
              summaryPending={props.userSummaryPending}
              onChangeHandle={onStatusFilterChange}
            />
          )
          /* <ul id="inb-c-left-bar-flist--user-status"
                className="inb-vert-list">
                <span className="inb-list-title">
                {t('status')}
                </span>
              {['all', 'active','inactive'].map(status => (
              <ListItem
                  className={status === statusFilter.value ? 'active' : ''}
                  key={status}>

                  <span onClick={() => onStatusFilterChange(status)}>
                    {t(status)}
                  </span>

                  {statusFilter.value !== null && statusFilter.value !== 'all' && statusFilter.value == status &&
                  <a
                    href="#"
                    className="unset-filter"
                    onClick={() => onStatusFilterChange('all')}
                    title={t('unselect_filter')}>
                    x
                  </a>
                  }
              </ListItem>
              ))}
            </ul>*/
        }
        {props.activeSubmenu == "staff" && (
          <SidebarFilter
            id="inb-c-left-bar-flist--user-role"
            heading=""
            type="list"
            data={getFilterData(
              [
                { name: t("all"), summaryItem: "allCount", value: "all" },
                { name: t("role_admin"), value: "admin" },
                { name: t("role_manager"), value: "manager" },
                {
                  name: t("role_booking-manager"),
                  summaryItem: "booking_manager",
                  value: "booking-manager",
                },
                { name: t("role_mediator"), value: "mediator" },
                {
                  name: t("role_manager-location"),
                  summaryItem: "manager_location",
                  value: "manager-location",
                },
                {
                  name: t("role_garage-staff"),
                  summaryItem: "garage_staff",
                  value: "garage-staff",
                },
              ],
              props.userSummaryPending,
              props.userSummary,
            )}
            dataKey="value"
            selected={roleFilter.value}
            summaryPending={props.userSummaryPending}
            onChangeHandle={onRoleFilterChange}
          />
        )}
      </div>
      {/*<ul id="inb-c-left-bar-flist--user-role"
                className="inb-vert-list">
                <span className="inb-list-title">
                {t('role')}
                </span>
                <ListItem
                    className={roleFilter.value == 'all' ? 'active' : ''}
                    key={'role_all'}>

                    <span onClick={() => onRoleFilterChange('all')}>
                    {t('all')}
                    </span>
                </ListItem>
              {props.getAvailableRoles().map(role => (
              <ListItem
                  className={role === roleFilter.value ? 'active' : ''}
                  key={role}>

                  <span onClick={() => onRoleFilterChange(role)}>
                    {t('role_' + role)}
                  </span>

                  {roleFilter.value !== null && roleFilter.value !== 'all' && roleFilter.value == role &&
                  <a
                    href="#"
                    className="unset-filter"
                    onClick={() => onRoleFilterChange('all')}
                    title={t('unselect_filter')}>
                    x
                  </a>
                  }
              </ListItem>
              ))}
            </ul>}*/}
      <footer
        className="inb-c-left-bar__footer small-only-float-container"
        data-inb-action-link="write"
      >
        <a
          href="#"
          id="toggle-left-bar"
          className="button secondary show-for-small-only"
          onClick={(e) => onToggleLeftBar(e)}
        >
          <i className="fi fi-filter"></i>
          <span className="show-for-sr">{t("open_filter_menu")}</span>
        </a>
        {rbac.hasPermission("write") && (
          <NewUserButton
            url={
              "/users/add?path=" +
              (props.activeSubmenu == "staff" ? "/users/staff" : "/users") +
              currentUrl.search.replace("?", "&")
            }
          />
        )}
      </footer>
    </aside>
  );
};

export default UserSidebar;
